var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRedTimer(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M10.8717 20.1664C15.1293 20.1664 18.5808 16.7149 18.5808 12.4572C18.5808 8.19956 15.1293 4.74805 10.8717 4.74805C6.61402 4.74805 3.16251 8.19956 3.16251 12.4572C3.16251 16.7149 6.61402 20.1664 10.8717 20.1664Z",
    fill: "#E65C6C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 12.421C10.8184 12.4186 10.6449 12.3454 10.5165 12.217C10.3881 12.0886 10.3149 11.9151 10.3125 11.7335V7.81934C10.3125 7.637 10.3849 7.46213 10.5139 7.3332C10.6428 7.20427 10.8177 7.13184 11 7.13184C11.1823 7.13184 11.3572 7.20427 11.4861 7.3332C11.6151 7.46213 11.6875 7.637 11.6875 7.81934V11.7335C11.6851 11.9151 11.6119 12.0886 11.4835 12.217C11.3551 12.3454 11.1816 12.4186 11 12.421Z",
    fill: "#E65C6C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2092 3.23535H8.53418C8.35184 3.23535 8.17697 3.16292 8.04804 3.03399C7.91911 2.90506 7.84668 2.73019 7.84668 2.54785C7.84668 2.36552 7.91911 2.19065 8.04804 2.06172C8.17697 1.93278 8.35184 1.86035 8.53418 1.86035H13.2092C13.3915 1.86035 13.5664 1.93278 13.6953 2.06172C13.8242 2.19065 13.8967 2.36552 13.8967 2.54785C13.8967 2.73019 13.8242 2.90506 13.6953 3.03399C13.5664 3.16292 13.3915 3.23535 13.2092 3.23535Z",
    fill: "#E65C6C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRedTimer);
export default __webpack_public_path__ + "static/media/red-timer.85584bc4914d219dd9e1d772e1a8c61d.svg";
export { ForwardRef as ReactComponent };